import { ReactComponent as IcBack24 } from './icon/ic_back_24.svg'
import { ReactComponent as IcPin24 } from './icon/ic_pin_24.svg'
import { ReactComponent as IcClearButton36 } from './icon/ic_clear_button_36.svg'
import { ReactComponent as IcSearch36 } from './icon/ic_search_36.svg'
import { ReactComponent as IcCheck } from './icon/ic_check.svg'
import { ReactComponent as IcError } from './icon/ic_error.svg'
import { ReactComponent as IcPassed } from './icon/ic_passed.svg'
import { ReactComponent as IcNext24 } from './icon/ic_next_24.svg'
import { ReactComponent as IcSocialGoogle } from './icon/ic_social_google.svg'
import { ReactComponent as IcSocialApple } from './icon/ic_social_apple.svg'
import { ReactComponent as IcSocialKakao } from './icon/ic_social_kakao.svg'
import { ReactComponent as IcSocialNaver } from './icon/ic_social_naver.svg'
import { ReactComponent as IcSocialLine } from './icon/ic_social_line.svg'

export default {
    IcBack24,
    IcPin24,
    IcClearButton36,
    IcSearch36,
    IcCheck,
    IcError,
    IcPassed,
    IcNext24,
    IcSocialGoogle,
    IcSocialApple,
    IcSocialKakao,
    IcSocialNaver,
    IcSocialLine,
}
